import * as React from "react";
import { BasePureComponent } from "./BaseComponent";
import { AutocompleteInput, Trad } from "./";

import * as Dati from "../Dati";
import * as Glob from "../Globale";

interface IIndirizziProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON; //JSON rubrica
    ID_TipoAnagPrincipale?: string;
    OnChangeAppendice?: (e: React.FormEvent<any> | string, valore: any, label: string, fieldTypeId: number, elementGroup?: any) => any;
}

export const IndiceSedeLegale = 0;

export class Indirizzi extends BasePureComponent<IIndirizziProps> {
    private _Dati: Dati.CDatoIndirizzo[] = [];
    private _Tipi: string[] = [];
    private _Checked: boolean[] = [];
    private _IsMainAddressRequired: boolean = false;

    public constructor(props: any) {
        super(props);
    }

    private OnRimuovi(indice: number) {
        const { OnChange, OnChangeAppendice, Name } = this.props;

        this._Dati.splice(indice, 1);

        if (this._Dati.length > 0 && this._IsMainAddressRequired) {
            this._Dati[0].Tipo = [IndiceSedeLegale];
        }

        OnChange(Name, JSON.stringify(this._Dati));
        if (OnChangeAppendice) {
            OnChangeAppendice(`${Name}[${indice.toString()}]`, {}, Name, 0);
        }
    }

    private OnAggiungi() {
        let dato: Dati.CDatoIndirizzo = new Dati.CDatoIndirizzo();

        if (this._Dati.length == 0 && this._IsMainAddressRequired) {
            dato.Tipo = [IndiceSedeLegale];
        }
        this._Dati.push(dato);
        this.props.OnChange(this.props.Name, JSON.stringify(this._Dati));
    }

    protected OnAggiorna(c: string, i: number, v: any): any {
        const { OnChange, OnChangeAppendice, Name } = this.props;

        switch (c) {
            case "Indirizzo":
                this._Dati[i].Indirizzo = v;
                break;
            case "Citta":
                this._Dati[i].Citta = v;
                break;
            case "Cap":
                this._Dati[i].Cap = v;
                break;
            case "Nazione":
                this._Dati[i].Nazione = v;
                break;
            case "Provincia":
                this._Dati[i].Provincia = v;
                break;
            case "Tipo":
                if (v) {
                    let ESL = this.EsisteSedeLegale();
                    if (ESL >= 0 && i != ESL && v == IndiceSedeLegale && this._Dati[i].Tipo.indexOf(Number(v)) < 0) {
                        Glob.InfoModaleWarning(Trad.Trad("WARNING"), Trad.Trad("EsisteGiaUnaSedeLegaleImpossibileImpostarneUnaSeconda"));
                    } else {
                        //Se c'è lo rimuove, altrimenti il contrario
                        if (this._Dati[i].Tipo.indexOf(Number(v)) >= 0) {
                            this._Dati[i].Tipo.splice(this._Dati[i].Tipo.indexOf(Number(v)), 1);
                        } else {
                            this._Dati[i].Tipo.push(Number(v));
                        }
                    }
                }
                break;
        }
        OnChange(Name, JSON.stringify(this._Dati));
        if (OnChangeAppendice) {
            OnChangeAppendice(`${Name}[${i.toString()}]`, JSON.stringify(this._Dati[i]), Name, 0, this.getElementGroup(i));
        }
    }

    private EsisteSedeLegale() {
        let Trovata: number = -1;
        for (let i: number = 0; i < this._Dati.length; i++) {
            for (let y: number = 0; y < this._Dati[i].Tipo.length; y++) {
                if (this._Dati[i].Tipo[y] == IndiceSedeLegale) {
                    Trovata = i;
                    break;
                }
            }
        }
        return Trovata;
    }

    private Inizializza(props: IIndirizziProps) {
        this._IsMainAddressRequired =
            props.ID_TipoAnagPrincipale == Glob.Tipi_TAP_PersonaGiuridica ||
            props.ID_TipoAnagPrincipale == Glob.Tipi_TAP_PersonaFisica ||
            props.ID_TipoAnagPrincipale == Glob.Tipi_TAP_DittaIndividuale;

        this.PopolaDati(props);
    }

    private PopolaTipi() {
        this._Tipi = []; //L'ordine è l'indice di salvataggio
        this._Checked = [];

        //controllo se ID_TipoAnagPrincipale=8 società | ID_TipoAnagPrincipale=7 persona fisica
        if (this.props.ID_TipoAnagPrincipale != undefined && (this.props.ID_TipoAnagPrincipale == Glob.Tipi_TAP_PersonaGiuridica || this.props.ID_TipoAnagPrincipale == Glob.Tipi_TAP_ATI)) {
            this.PopolaArraySistema(Trad.Trad("Sede Legale")); //0
            this.PopolaArraySistema(Trad.Trad("Sede Principale")); //1
            this.PopolaArraySistema(Trad.Trad("Sede Secondaria")); //2
        } else if (
            this.props.ID_TipoAnagPrincipale != undefined &&
            (this.props.ID_TipoAnagPrincipale == Glob.Tipi_TAP_PersonaFisica || this.props.ID_TipoAnagPrincipale == Glob.Tipi_TAP_DittaIndividuale)
        ) {
            this.PopolaArraySistema(Trad.Trad("Domicilio")); //3
            this.PopolaArraySistema(Trad.Trad("Residenza")); //4
            this.PopolaArraySistema(Trad.Trad("Ufficio")); //5
        } else {
            this.PopolaArraySistema("Sede Legale"); //0
            this.PopolaArraySistema("Sede Principale"); //1
            this.PopolaArraySistema("Sede Secondaria"); //2

            this.PopolaArraySistema("Domicilio"); //3
            this.PopolaArraySistema("Residenza"); //4
            this.PopolaArraySistema("Ufficio"); //5
        }
    }

    private PopolaArraySistema(valore: string) {
        this._Tipi.push(valore);
        this._Checked.push(false);
    }

    private InizializzaArrayChecked() {
        for (let i: number = 0; i < this._Checked.length; i++) {
            this._Checked[i] = false;
        }
    }

    private TipoIcona(tipo: number): string {
        switch (tipo) {
            case 1:
                return "la-phone";
            case 2:
                return "la-mobile";
            case 3:
                return "la-fax";
            case 4:
                return "la-envelope";
            case 5:
                return "la-gavel";
        }
        return "la-edit";
    }

    private PopolaDati(Props: IIndirizziProps) {
        this.PopolaTipi();
        let DatiApp: Dati.CDatoIndirizzo[] = [];
        if (Props.Value != undefined && Props.Value != "") {
            if (typeof Props.Value == "string") {
                DatiApp = JSON.parse(Props.Value);
            } else {
                DatiApp = Props.Value;
            }
        }
        this._Dati = DatiApp;
    }

    private PopolaCheckBox(attivi: number[], index: number): any {
        let checkbox: any[] = [];

        this.InizializzaArrayChecked();
        for (let y: number = 0; y < attivi.length; y++) {
            this._Checked[attivi[y]] = true;
        }

        for (let i: number = 0; i < this._Tipi.length; i++) {
            checkbox.push(
                <div className="col-lg-2" key={i + 100}>
                    <label className="kt-checkbox kt-checkbox--solid kt-checkbox--brand">
                        <input
                            value={i}
                            type="checkbox"
                            disabled={i == 0 && this._Checked[i] && this._IsMainAddressRequired}
                            checked={this._Checked[i]}
                            key={i * 10}
                            onChange={e => {
                                this.OnAggiorna("Tipo", index, e.currentTarget.value);
                            }}
                        />
                        {Trad.Trad(this._Tipi[i])}
                        <span></span>
                    </label>
                </div>
            );
        }
        return checkbox;
    }

    private getElementGroup(index: number) {
        const elementGroup = [];
        for (let key in this._Dati[index]) {
            if (key === "Tipo") {
                for (let x: number = 0; x < this._Dati[index]["Tipo"].length; x++) {
                    elementGroup.push({
                        ValoreAppendice: this._Dati[index][key],
                        Etichetta: this._Tipi[x],
                        ID_TipoCampo: 5
                    });
                }
            } else {
                elementGroup.push({
                    ValoreAppendice: this._Dati[index][key],
                    Etichetta: key
                });
            }
        }
        return elementGroup;
    }

    private onPlaceChange = (index: number) => (address: any) => {
        const { OnChange, Name } = this.props;

        this._Dati[index] = {
            ...this._Dati[index],
            Indirizzo: `${address.route || ""} ${address.street_number || ""}`,
            Citta: address.locality || address.administrative_area_level_3 || "",
            Cap: address.postal_code || "",
            Provincia: address.administrative_area_level_2 || "",
            Nazione: address.country || ""
        };
        OnChange(Name, JSON.stringify(this._Dati));
    };

    public render() {
        this.Inizializza(this.props);

        let valori: any[] = [];
        for (let i: number = 0; i < this._Dati.length; i++) {
            let chekbox: any[] = this.PopolaCheckBox(this._Dati[i].Tipo, i);
            const isFormDisabled = !(this._Dati[i].Indirizzo || this._Dati[i].Citta || this._Dati[i].Cap || this._Dati[i].Provincia || this._Dati[i].Nazione);

            valori.push(
                <div className="form-group special-group kt-form login-form__group" key={i + 1}>
                    <AutocompleteInput OnPlaceChange={this.onPlaceChange(i)} />
                    <div className="row">
                        <div className="col-lg-4">
                            <label>{Trad.Trad("Indirizzo")}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this._Dati[i].Indirizzo}
                                readOnly={isFormDisabled}
                                onChange={e => {
                                    this.OnAggiorna("Indirizzo", i, e.currentTarget.value);
                                }}
                            />
                        </div>
                        <div className="col-lg-4">
                            <label>{Trad.Trad("Citta")}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this._Dati[i].Citta}
                                readOnly={isFormDisabled}
                                onChange={e => {
                                    this.OnAggiorna("Citta", i, e.currentTarget.value);
                                }}
                            />
                        </div>
                        <div className="col-lg-2">
                            <label>{Trad.Trad("CAP")}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this._Dati[i].Cap}
                                readOnly={isFormDisabled}
                                onChange={e => {
                                    this.OnAggiorna("Cap", i, e.currentTarget.value);
                                }}
                            />
                        </div>
                        <div className="col-lg-4">
                            <label>{Trad.Trad("Provincia")}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this._Dati[i].Provincia}
                                readOnly={isFormDisabled}
                                onChange={e => {
                                    this.OnAggiorna("Provincia", i, e.currentTarget.value);
                                }}
                            />
                        </div>
                        <div className="col-lg-4">
                            <label>{Trad.Trad("Nazione")}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this._Dati[i].Nazione}
                                readOnly={isFormDisabled}
                                onChange={e => {
                                    this.OnAggiorna("Nazione", i, e.currentTarget.value);
                                }}
                            />
                        </div>
                        <div className="kt-checkbox-list checkbox-list col-lg-12">
                            <div className="form-group special-group kt-form login-form__group row">
                                <div className=" row col-lg-11">{chekbox}</div>
                                <div className="col-lg-1 remove-square-button">
                                    <button type="button" className="btn btn-danger square-button-with-icon" onClick={() => this.OnRimuovi(i)} title={Trad.Trad("Elimina")}>
                                        {" "}
                                        <i className="fa fa-minus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="kt-portlet bg-fill-brand kt-portlet--head-solid-bg kt-portlet--bordered">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-map-marker-alt"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">{Trad.Trad("Indirizzi")}</h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            <li className="kt-portlet__nav-item">
                                <a
                                    href="#"
                                    onClick={e => {
                                        e.preventDefault();
                                        this.OnAggiungi();
                                    }}
                                    className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black"
                                    title={Trad.Trad("Nuovo indirizzo")}
                                >
                                    <i className="fa fa-plus"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="kt-portlet__body">{valori}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Indirizzi.tsx